// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SavePrintedDocumentDataMutationVariables = Types.Exact<{
  saveCashRegisterPrintRequestDTO: Types.SavePrintedDocumentDataRequestDtoInput;
}>;


export type SavePrintedDocumentDataMutationResult = { __typename?: 'Mutation', savePrintedDocumentData: boolean };

export const SavePrintedDocumentDataGql = gql`
    mutation SavePrintedDocumentData($saveCashRegisterPrintRequestDTO: SavePrintedDocumentDataRequestDTOInput!) {
  savePrintedDocumentData(
    saveCashRegisterPrintRequestDTO: $saveCashRegisterPrintRequestDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePrintedDocumentDataInjectable extends Apollo.Mutation<SavePrintedDocumentDataMutationResult, SavePrintedDocumentDataMutationVariables> {
    override document = SavePrintedDocumentDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */